import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Space, Tabs } from 'antd';
import { DOCTOR_HOW_IT_WORKS_PAGES } from '@medicusunion/front-utils';
import { SIDEBAR_ICONS } from 'constants/layout';
import { useNavigate, useParams } from 'react-router-dom';
import { CONFIG_PAGES } from 'constants/static';
import { ConfigRow, fetchConfigByType } from 'services/api/config';

import { StyledPage } from './styled';
import { Loading, PageWrapper } from 'components/ui';

const HowItWorks: FC = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const { id } = useParams();

  const [data, setData] = useState<ConfigRow | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchConfigByType(CONFIG_PAGES.DOCTOR_HOW_IT_WORKS)
      .then(setData)
      .catch(() => setData(null))
      .finally(() => setLoading(false));
  }, []);

  const result = data?.body?.[`${id}`]?.desktop?.[i18n.language]?.content;

  const items = Object.values(DOCTOR_HOW_IT_WORKS_PAGES)
    .sort((a, b) => a.order - b.order)
    .map(item => ({
      key: item.key,
      label: (
        <Space>
          {SIDEBAR_ICONS[item.key]}
          {t(`how_it_works.${item.key}`)}
        </Space>
      )
    }));

  const onChangeTab = (key: string) => {
    navigate(`/how-it-works/${key}`);
  };

  return (
    <PageWrapper title={t('how_it_works.title')} color="white">
      <StyledPage>
        <Tabs activeKey={id} onChange={onChangeTab} items={items} />
        {loading ? (
          <Loading />
        ) : (
          <div
            className="how-it-works-content"
            dangerouslySetInnerHTML={{ __html: result }}
          />
        )}
      </StyledPage>
    </PageWrapper>
  );
};

export default HowItWorks;
